import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BrowserService } from 'src/app/services/browser.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: false,
})
export class PagesComponent implements OnDestroy {
  @ViewChild('mainContent') private mainContent?: ElementRef<HTMLElement>;

  public selectedDate: Date = new Date();
  // private loading = new BehaviorSubject<boolean>(null);
  public loading$: Observable<boolean>;
  public menuOpen = false;
  private routerSub: Subscription;
  readonly unsupportedBrowserMessage: string =
    'You’re on an unsupported browser, please use the latest version of either Edge or Chrome instead.';

  constructor(private browserService: BrowserService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.loading$ = this.loadingService.loading;
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.closeMenu();
        const el = this.mainContent?.nativeElement;
        if (el) {
          // Dev: Temporarily enable aria-live on navigation to announce new screen, then auto-remove to prevent duplicate dropdown announcements (SEDMS-9596)
          el.setAttribute('aria-live', 'polite');
          setTimeout(() => {
            el.removeAttribute('aria-live');
          }, 1000);
        }
      });
    if (!this.browserService.isEdge() && !this.browserService.isChrome()) {
      this.notificationService.show({
        content: this.unsupportedBrowserMessage,
        cssClass: 'notification-error pages-notification-font',
        position: { horizontal: 'center', vertical: 'top' },
        animation: { type: 'slide', duration: 60 },
        type: { style: 'warning', icon: true },
        closable: true,
      });
    }
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
  skipToMainContent(event: Event): void {
    event.preventDefault();
    if (this.mainContent?.nativeElement) {
      this.mainContent.nativeElement.focus();
      this.mainContent.nativeElement.scrollIntoView();
    }
  }
}
